<script setup>
definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Clearing Report";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Report",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];

const statuses = [
  {
    title: "Onboarding",
    value: "onboarding",
  },
  {
    title: "In Service",
    value: "inservice",
  },
  {
    title: "Suspended",
    value: "suspended",
  },
  {
    title: "Withdrawal",
    value: "withdrawal",
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">Search {{ pageTitle }}</h4>
  <VCard>
    <VCardText>
      <ClearingReportIndex />
    </VCardText>
  </VCard>
</template>
